"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3 12.083c.044-2.469.849-4.553 2.495-6.29 1.48-1.563 3.309-2.474 5.438-2.729a9 9 0 0 1 9.738 6.51c.152.547-.23 1.003-.702.964-.304-.024-.534-.226-.633-.58a7.4 7.4 0 0 0-1.246-2.53c-1.31-1.708-3.032-2.72-5.168-2.984a7.59 7.59 0 0 0-8.4 6.157c-.697 3.73 1.42 7.359 5.025 8.613.454.158.65.579.454.976-.16.326-.505.463-.874.338a8.8 8.8 0 0 1-2.92-1.644c-1.787-1.528-2.822-3.469-3.135-5.796-.048-.358-.052-.723-.072-1.005"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.714 13.89a2.787 2.787 0 0 1 2.798-2.782c1.534-.001 2.795 1.244 2.803 2.765.008 1.544-1.247 2.794-2.805 2.795a2.774 2.774 0 0 1-2.796-2.778m2.79 1.394c.791.001 1.421-.61 1.425-1.381a1.407 1.407 0 0 0-1.42-1.41c-.779 0-1.418.628-1.421 1.395-.003.766.634 1.395 1.416 1.396m.016 1.833h2.102a2.355 2.355 0 0 1 2.373 2.32q.01.426 0 .85c-.008.42-.29.712-.682.713-.405 0-.687-.294-.691-.723-.003-.252 0-.505-.001-.757-.005-.591-.42-1.016-1.007-1.017a921 921 0 0 0-4.205 0c-.585 0-.995.413-1.001.998-.003.264.006.53-.003.793-.013.392-.265.67-.622.702a.68.68 0 0 1-.741-.525 1 1 0 0 1-.017-.257c.022-.44-.007-.892.083-1.319.214-1.023 1.186-1.77 2.235-1.776.725-.005 1.45-.001 2.176-.001M12.69 10.04v2.453c-.002.525-.259.781-.78.781H8.001a.65.65 0 0 1-.621-.385c-.127-.253-.108-.516.082-.722.108-.118.278-.185.43-.252.074-.033.17-.016.256-.016l2.912-.001q.254 0 .255-.248-.002-2.056 0-4.113c.001-.4.24-.685.592-.723.44-.047.766.238.78.68q.002.083.001.167z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=RequestsIcon24.js.map